import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { charterSelector } from '../../../../../../store/reducers/charterSlice/charterSlice';
import { CharterItem } from '../../CharterItem/CharterItem';
import { PositionItem } from '../../PositionItem/PositionItem';
import { positionSelector } from '../../../../../../store/reducers/positionSlice/positionSlice';

export const StageChildItem = ({ childGuid }) => {
    const charters = useSelector(charterSelector.selectEntities);
    const positions = useSelector(positionSelector.selectEntities);

    const chartersGuids = useSelector(charterSelector.selectIds);

    const isCharter = chartersGuids.includes(childGuid);

    return (
        <>
            {isCharter ? (
                <CharterItem charter={charters[childGuid]} />
            ) : (
                <PositionItem position={positions[childGuid]} />
            )}
        </>
    );
};
